export default __webpack_public_path__ + "static/media/client.0dd71f03.svg";